export const translations = {
  apply_now: {
    _: 'Apply Now',
    zh: '立即申請',
  },
  buy_now: {
    _: 'Buy Now',
    zh: '立即投保',
  },
  check_price: {
    _: 'Check Price',
    zh: '查看價格',
  },
};
